module.exports = __webpack_public_path__ + "files/9b39f6a6e5204e7a69ed3c5da0abd918.png";